import { StateUtils } from '@spartacus/core';
import { EMAIL_SUBSCRIPTION_ENTITY } from '../promo-state';

export const SUBSCRIBE_EMAIL = '[Email Subscription] Subscribe';
export const SUBSCRIBE_EMAIL_SUCCESS = '[Email Subscription] Subscribe Success';
export const SUBSCRIBE_EMAIL_FAILURE = '[Email Subscription] Subscribe Failure';
export const SUBSCRIBE_EMAIL_RESET = '[Email Subscription] Subscribe Reset';

export class SubscribeEmail extends StateUtils.LoaderLoadAction {
  readonly type = SUBSCRIBE_EMAIL;

  constructor(
    public email: string,
    public isLoggedIn: boolean,
  ) {
    super(EMAIL_SUBSCRIPTION_ENTITY);
  }
}

export class SubscribeEmailSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SUBSCRIBE_EMAIL_SUCCESS;

  constructor(public payload: boolean) {
    super(EMAIL_SUBSCRIPTION_ENTITY);
  }
}

export class SubscribeEmailFailure extends StateUtils.LoaderFailAction {
  readonly type = SUBSCRIBE_EMAIL_FAILURE;

  constructor(public payload: unknown) {
    super(EMAIL_SUBSCRIPTION_ENTITY, payload);
  }
}

export class SubscribeEmailReset extends StateUtils.LoaderResetAction {
  readonly type = SUBSCRIBE_EMAIL_RESET;

  constructor() {
    super(EMAIL_SUBSCRIPTION_ENTITY);
  }
}

export type EmailSubscriptionActions =
  | SubscribeEmail
  | SubscribeEmailSuccess
  | SubscribeEmailFailure
  | SubscribeEmailReset;
